import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import styled from 'styled-components'

import { FlexColumn, FlexContainer, FlexRow } from '../FlexboxReusables/FlexItems'
import { Logo } from '../../assets/Logo'
import CourseDropdown from './CourseDropdown'
import UserDropdown from './UserDropdown'
import ResultsDropdown from './ResultsDropdown'
import CourseCatalogDropdown from './CourseCatalogDropdown'
import { ThemeContext } from '../../Theme/ThemeContext'
import { AuthContext } from '../Auth/AuthContext'
import { UserRole } from '../User/types'

const Navigation: React.FC = () => {
  const { isDarkMode } = useContext(ThemeContext)
  const { authUser } = useContext(AuthContext)
  const role = authUser.role.toLowerCase() as UserRole

  const conditionallyRenderDropdownsBasedOnRole = () => {
    switch (role) {
      case UserRole.CLIENT:
        return (
          <>
            <FlexColumn width='15vw' margin='0.5em 0 0 0'>
              <CourseCatalogDropdown />
            </FlexColumn>
            <FlexColumn width='15vw'>
              <ResultsDropdown />
            </FlexColumn>
          </>
        )
      case UserRole.ADMIN:
        return (
          <>
            <FlexColumn width='15vw'>
              <CourseDropdown />
            </FlexColumn>
            <FlexColumn width='15vw'>
              <ResultsDropdown />
            </FlexColumn>
          </>
        )
      default:
        return <></>
    }
  }

  return (
    <NavigationContainer isDarkMode={isDarkMode}>
      <LogoRow width='10em'>
        <FlexColumn>
          <FlexRow>
            <Link to='/'>
              <CompanyLogo />
            </Link>
          </FlexRow>
          <FlexRow style={{flexWrap: 'wrap'}}>
            <CourseWareText>CourseWare</CourseWareText>
          </FlexRow>
        </FlexColumn>
      </LogoRow>
      <FlexRow>
        {conditionallyRenderDropdownsBasedOnRole()}
      </FlexRow>
      <FlexRow width='8em'>
        <UserDropdown />
      </FlexRow>
    </NavigationContainer>
  )
}

export default injectIntl(Navigation)

const CompanyLogo = styled(Logo)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5em;
  z-index: 99;
`

const NavigationContainer = styled(FlexContainer)`
  height: 65px;
  border-bottom: 3px solid #e8e8e8;
`

const LogoRow = styled(FlexRow)`
  border-right: 3px solid #e8e8e8;
  padding-top: 5px;
  margin-top: 5px;
`

const CourseWareText = styled.h1`
  font-size: 14px;
  font-weight: bold;
  color: #14CCAA;
`